export const readId = (state) => state.id;
export const readFilter = (state) => state.filter;
export const readAgencies = (state) => state.agencies;
export const readAgency = (state) => state.agency;
export const readError = (state) => state.error;
